module.exports = __webpack_public_path__ + "static/media/5.2bdb8368.png";